export function setInCookie(name: string, value, nDays: number) {
    const date = new Date();
    date.setDate(date.getDate() + nDays);

    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
}

export function getFromCookie(name: string): string | null {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");

    if (parts != null && parts.length == 2) {
        return parts.pop()!.split(";").shift() ?? null;
    }

    return null;
}

export function getFromCookieAsNumber(key: string): number | null {
    const cookieValueAsString = getFromCookie(key);
    if (!cookieValueAsString) return null;

    const cookieValueAsNumber = Number.parseInt(cookieValueAsString);
    if (isNaN(cookieValueAsNumber) || Number.isNaN(cookieValueAsNumber)) {
        return null;
    }

    return cookieValueAsNumber;
}

export function getFromCookieAsBoolean(key: string): boolean | null {
    const cookieValueAsString = getFromCookie(key);
    if (!cookieValueAsString) return null;

    return cookieValueAsString.toLowerCase() === "true";
}
